import { borderHighlightOnly } from './errorBorder'
import {
  emptyString,
  noSpecialChars,
  email,
  length,
  RegexValidator,
  isValidLatitudeTenant,
  isValidLongitudeTenant,
  checkTrue,
  positiveFloat
} from './index'
import { alert } from '@/plugins/notification'
export default (body) => {
  const showAlert = false
  const showMessage = true
  let count = 0
  if (!emptyString(body.firstName, 'First Name', 'FirstName', showAlert, showMessage, undefined)) {
    count++
  } else if (!noSpecialChars(body.firstName, 'First Name', 'FirstName', showAlert, showMessage, undefined)) {
    count++
  }
  if (!emptyString(body.lastName, 'Last Name', 'LastName', showAlert, showMessage)) {
    count++
  } else if (!noSpecialChars(body.lastName, 'Last Name', 'LastName', showAlert, showMessage, undefined)) {
    count++
  }
  if (!email(body.email, 'Email', 'Email', showAlert, showMessage, undefined)) {
    count++
  }
  if (!emptyString(body.companyName, 'Company Name', 'CompanyName', showAlert, showMessage, undefined)) {
    count++
  }
  if (!email(body.companyEmail, 'Company Email', 'CompanyEmail', showAlert, showMessage, undefined)) {
    count++
  }
  if (!length(body.companyPhone, 'Phone Number', 6, 10, 'CompanyPhoneNumber', showAlert, showMessage, undefined)) {
    count++
  }
  if (!RegexValidator(body.GSTIN, '[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}', 'Invalid Company Gst Number', 'CompanyGstNumber', showAlert, showMessage)) {
    count++
  }
  if (!RegexValidator(body.PAN, '[A-Z]{5}[0-9]{4}[A-Z]{1}', ' Invalid Company PAN Number', 'CompanyPanNumber', showAlert, showMessage)) {
    count++
  }
  if (!isValidLatitudeTenant(body.latitude, 'Latitude', 'Latitude', showAlert, showMessage, undefined)) {
    count++
  }
  if (!isValidLongitudeTenant(body.longitude, 'Longitude', 'Longitude', showAlert, showMessage, undefined)) {
    count++
  }
  if (!checkTrue(body.industryVertical, 'Please select industry vertical', 'Industry', showAlert, showMessage)) {
    count++
  }
  count += materialCheck(body)
  if (count > 0) {
    alert('Please check the highlighted regions')
    return false
  }
  return count === 0
}
export function materialCheck (body) {
  const showAlert = false
  const showMessage = true
  let count = 0
  if (body.approval_workflow) {
    if (!body?.materials) {
      return count //  for closed tennat wf there will be instnce id , in suh cased (body?.materials becomes undefined
    }
    if (body?.materials?.length === 0) {
      borderHighlightOnly('materials-empty', true)
      count++
    }
    body.materials.forEach((material, index) => {
      if (material.flag === 'delete') {
        return
      }
      if (!positiveFloat(material.moq, 'MOQ', `moq-${material.material_id}`, showAlert, showMessage)) {
        count++
      }
      if (!positiveFloat(material.lead_time, 'LeadTime', `leadTime-${material.material_id}`, showAlert, showMessage)) {
        count++
      }
      count += tierPricingCheck(material)
      if (validateTierPricingOverlap(material)) {
        count++
      }
    })
  }
  return count
}
export function validateTierPricingOverlap (material) {
  const showAlert = false
  const showMessage = true

  const rows = material.tier_pricing
    .map((t, index) => ({
      index,
      flag: t.flag,
      min: t.min_qty !== '' && t.min_qty !== null ? Number(t.min_qty) : null,
      max: t.max_qty !== '' && t.max_qty !== null ? Number(t.max_qty) : null
    }))
    .filter(r => r.flag !== 'delete')

  // Sort by min (nulls last)
  rows.sort((a, b) => {
    if (a.min === null) return 1
    if (b.min === null) return -1
    return a.min - b.min
  })

  let overlapFound = false

  for (let i = 1; i < rows.length; i++) {
    const prev = rows[i - 1]
    const curr = rows[i]

    if (curr.min === null || prev.min === null) continue

    // Determine prev.max for comparison
    const prevMax = prev.max !== null ? prev.max : Infinity

    if (curr.min <= prevMax) {
      overlapFound = true
      // previous row
      if (prev.min !== null) {
        positiveFloat(null, 'Min Qty', `tp-${material.material_id}-${prev.index}-minQty`, showAlert, showMessage, 'overlapping price tier')
      }
      if (prev.max !== null) {
        positiveFloat(null, 'Max Qty', `tp-${material.material_id}-${prev.index}-maxQty`, showAlert, showMessage, 'overlapping price tier')
      }

      // current row
      if (curr.min !== null) {
        positiveFloat(null, 'Min Qty', `tp-${material.material_id}-${curr.index}-minQty`, showAlert, showMessage, 'overlapping price tier')
      }
      if (curr.max !== null) {
        positiveFloat(null, 'Max Qty', `tp-${material.material_id}-${curr.index}-maxQty`, showAlert, showMessage, 'overlapping price tier')
      }
    }
  }

  return overlapFound
}

export function tierPricingCheck (material) {
  const showAlert = false
  const showMessage = true
  let count = 0
  let contentAvailableIndex = -1
  const actualIndex = material.tier_pricing.filter((item) => item.flag !== 'delete')?.length - 1
  material.tier_pricing.forEach((pricingrow, pricingIndex) => {
    if (pricingrow.flag === 'delete') {
      return
    }
    contentAvailableIndex++
    if (!positiveFloat(pricingrow.min_qty, 'Min Qty', `tp-${material.material_id}-${pricingIndex}-minQty`, showAlert, showMessage)) {
      count++
    }
    if (pricingrow.max_qty || (!pricingrow.max_qty && contentAvailableIndex !== actualIndex)) {
      if (!positiveFloat(pricingrow.max_qty, 'Max Qty', `tp-${material.material_id}-${pricingIndex}-maxQty`, showAlert, showMessage)) {
        count++
      }
    }
    if (pricingrow.max_qty && pricingrow.min_qty && pricingrow.max_qty < pricingrow.min_qty) {
      positiveFloat(null, 'Min Qty', `tp-${material.material_id}-${pricingIndex}-minQty`, showAlert, showMessage, 'should be less than max qty')
      positiveFloat(null, 'Max Qty', `tp-${material.material_id}-${pricingIndex}-maxQty`, showAlert, showMessage, 'should be greater than min qty')
      count++
    }
    if (!positiveFloat(pricingrow.unit_cost, 'Price', `tp-${material.material_id}-${pricingIndex}-unitPrice`, showAlert, showMessage)) {
      count++
    }
  })
  return count
}
